import request from '../request'
export function queryNews(classCName){
  return request({
    url: '/rest/wNtNews/queryNews/'+classCName,
    method: 'get'
  })
}
export function queryByCName(classCName){
  return request({
    url: '/rest/wNtNews/queryByCName/'+classCName,
    method: 'get'
  })
}
export function queryByClassId(classId,page,size){
  return request({
    url: '/rest/wNtNews/queryNewsByPage',
    method: 'get',
    params: {
      classId: classId,
      page: page,
      size: size,
    }
  })
}
export function queryByNewsId(newsId){
  return request({
    url: '/rest/wNtNews/queryByNewsId',
    method: 'get',
    params: {
      newsId: newsId
    }
  })
}
export function queryNewsByParentId(parentId){
  return request({
    url: '/rest/wNtNews/queryNewsByParentId',
    method: 'get',
    params: {
      parentId: parentId
    }
  })
}
export function download(newsId){
  return request({
    url: '/rest/wNtNews/download',
    method: 'get',
    params: {
      newsId: newsId
    }
  })
}

export function countByClassId(classId){
  return request({
    url: '/rest/wNtNews/countByClassId',
    method: 'get',
    params: {
      'classId': classId
    }
  })
}

export default { queryNews,queryByCName,queryByClassId,queryByNewsId,queryNewsByParentId,download,countByClassId }


// WEBPACK FOOTER //
// ./src/http/web/news.js